import { Box, Grid, Typography } from '@mui/material'
import { getDateFromString } from '../utils'
import { DataPanel } from './DataPanel'
import { DataTable } from './DataTable'

interface InstitutionalClaimPaymentsProps {
    data: any
}

export const InstitutionalClaimPayments = ({ data }: InstitutionalClaimPaymentsProps) => {
    const isClaimPrivateDataAvailable = data.claim?.privateData !== undefined
    data.payment = data.remittance
    let totalPaid = '--'
    let patientResponsibility = '--'
    if (data.payment !== undefined && data.payment !== null) {
        for (const payment of data.payment.publicData.payments) {
            if (payment.patientControlNumber === data.claim?.publicData.claimNumber) {
                totalPaid = payment.amountPaidByPayer
                patientResponsibility = payment.amountDueFromPatient
            }
        }
    }

    const paymentMethodContent = (
        <>
            <Typography variant="h6">Details</Typography>
            <DataTable
                isPrivateDataAvailable={isClaimPrivateDataAvailable}
                data={[
                    {
                        key: 'Method',
                        value: data.payment?.publicData?.paymentMethod,
                        private: false,
                    },
                    {
                        key: 'Payment Date',
                        value: data.payment?.publicData?.paymentDate,
                        private: false,
                    },
                    {
                        key: 'Total Paid (USD)',
                        value: totalPaid !== '--' ? `$${totalPaid} to provider` : totalPaid,
                        private: false,
                    },
                    { key: 'Payment Status', value: '--', private: false },
                    {
                        key: 'Check Number',
                        value: data.payment?.publicData?.paymentTransactionNumber,
                        private: false,
                    },
                    {
                        key: 'Check Date',
                        value: getDateFromString(
                            data.payment?.publicData?.paymentDate,
                        ).toLocaleDateString(),
                        private: false,
                    },
                    { key: 'Check Processed', value: '--', private: false },
                    { key: 'Check Type', value: '--', private: false },
                ]}
            />
        </>
    )
    const paymentContent = (
        <>
            <Typography variant="h6">Source</Typography>
            <DataTable
                isPrivateDataAvailable={isClaimPrivateDataAvailable}
                data={[
                    {
                        key: 'Name',
                        value: data.payment?.privateData?.paymentSourceName,
                        private: true,
                    },
                    {
                        key: 'ABA #',
                        value: data.payment?.privateData?.paymentSourceABA,
                        private: true,
                    },
                    {
                        key: 'Account #',
                        value: data.payment?.privateData?.paymentSourceAccountNumber,
                        private: false,
                    },
                ]}
            />
            <Box
                sx={{
                    marginTop: '20px',
                    marginBottom: '20px',
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            />
            <Typography variant="h6">Destination</Typography>
            <DataTable
                isPrivateDataAvailable={isClaimPrivateDataAvailable}
                data={[
                    {
                        key: 'Name',
                        value: data.payment?.privateData?.paymentDestinationName,
                        private: true,
                    },
                    {
                        key: 'ABA #',
                        value: data.payment?.privateData?.paymentDestinationABA,
                        private: true,
                    },
                    {
                        key: 'Account #',
                        value: data.payment?.privateData?.paymentDestinationAccountNumber,
                        private: false,
                    },
                ]}
            />
            <Box
                sx={{
                    marginTop: '20px',
                    marginBottom: '20px',
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            />
        </>
    )
    const paymentResponsibilityContent = (
        <>
            <DataTable
                isPrivateDataAvailable={isClaimPrivateDataAvailable}
                data={[
                    { key: 'Total', value: `$${patientResponsibility}`, private: false },
                    { key: 'Deductible', value: '--', private: false },
                    { key: 'Copay', value: '--', private: false },
                    { key: 'Coinsurance', value: '--', private: false },
                ]}
            />
            <Box
                sx={{
                    marginTop: '20px',
                    marginBottom: '20px',
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            />
        </>
    )
    return (
        <Grid container spacing={4}>
            <Grid item container lg={6} md={12} xs={12} spacing={4}>
                <Grid item xs={12}>
                    <DataPanel minHeight={150} title="Details" content={paymentMethodContent} />
                </Grid>
                <Grid item xs={12}>
                    <DataPanel minHeight={150} title="Routing" content={paymentContent ?? <></>} />
                </Grid>
            </Grid>
            <Grid item container lg={6} md={12} xs={12} spacing={4}>
                <Grid item xs={12}>
                    <DataPanel
                        minHeight={150}
                        title="Payment Responsibility"
                        content={paymentResponsibilityContent ?? <></>}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}
